import * as Constants from '../Constants'

export function setToken(token) {
  localStorage.setItem(Constants.TOKEN_STORAGE, token)
}

export function getToken() {
  return localStorage.getItem(Constants.TOKEN_STORAGE)
}

export function removeToken() {
  localStorage.removeItem(Constants.TOKEN_STORAGE)
}



// WEBPACK FOOTER //
// ./src/helpers/Storages/index.js